module.exports = __webpack_public_path__ + "img/carro.07a47df3.png";